import styled from "styled-components"
import media, {minWidthMedia} from "@irati/ui/src/global/media"

export const Details = styled.div`
  background-color: ${({theme}) => theme.colors.greys.lightest};
  color: ${({theme}) => theme.colors.greys.mediumDark};
  border-radius: 5px;
  padding: ${({theme}) => theme.spacing.two};

  ${minWidthMedia.tablet`
    display: flex;
    align-items: center;
  `}
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({theme}) => theme.spacing.two};

  ${media.tablet`
    margin-top: 10px;
  `};
`
